//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "CaroQuery",
	props: {
		query: String,
		setQuery: Function,
		sort: Object,
		setSort: Function,
		results: Object,
		executeSearch: Function,
		currentResultsStart: Number,
		currentResultsEnd: Number,
	},
	data() {
		return {
		};
	},
	computed: {
		queryModel: {
			get() {
				return this.query;
			},
			set(val) {
				this.setQuery(val);
			},
		},
	},
};
